import React, { useState, useEffect, memo, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import ProfileSection from "./common/ProfileSection";
import NavigationItem from "./common/NavigationItem";
import ProjectsMenu from "./common/ProjectsMenu";

const GeneralHeaderView = ({ navLinks, socialMediaIcons, onClickSetCurrentProject }) => {
  const [isProjectsOpen, setIsProjectsOpen] = useState(false);
  const navigate = useNavigate();

  const handleClickOutside = useCallback((event) => {
    const menuElement = document.getElementById("projects-menu-general");
    const target = event.target;
    
    const isClickInsideMenu = menuElement && menuElement.contains(target);
    const isClickOnProjectsNav = target.closest('li')?.querySelector('span')?.textContent === 'Projects';
    
    if (menuElement && !isClickInsideMenu && !isClickOnProjectsNav) {
      setIsProjectsOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [handleClickOutside]);

  const handleNavigation = useCallback((link) => {
    if (link.name === "Download CV") {
      window.open(link.link, '_blank');
    } else if (link.name === "Projects") {
      setIsProjectsOpen(prev => !prev);
    } else {
      navigate(link.link);
    }
  }, [navigate]);

  const renderNavOptions = useCallback(() => {
    return navLinks.map((link, index) => (
      <NavigationItem
        key={index}
        name={link.name}
        onClick={() => handleNavigation(link)}
      />
    ));
  }, [navLinks, handleNavigation]);

  return (
    <div className="flex w-full max-w-[360px] sm:max-w-[700px] xl:max-w-screen-2xl bg-gradient-to-br from-primary-50 to-primary-100 justify-center xl:flex-row flex-col mx-auto items-center h-[220px] mt-4 sm:mt-0 sm:h-[350px] ring-1 ring-primary-200 shadow-lg rounded-lg animate-fade-in">
      <ProfileSection 
        profile={{
          img: "https://onedrive.live.com/embed?resid=EA25B237AF1B5ED2%21128&authkey=%21ABAtDJL8nrinUXo&width=800&height=800",
          name: "Abdula Fazeli",
          role: "Game Developer"
        }} 
        socialMediaIcons={socialMediaIcons} 
      />

      <div className="w-full max-w-[360px] sm:max-w-[700px] h-auto sm:h-[auto] mt-[-45px] flex flex-col justify-center animate-slide-in-right">
        <nav className="flex w-full min-h-[40px] sm:min-h-[60px] justify-center items-center">
          <ul className="list-none flex flex-wrap w-full h-full shadow-lg rounded-md overflow-hidden gap-x-2 gap-y-2 px-2 py-2 bg-white/70 backdrop-blur-sm">
            {renderNavOptions()}
          </ul>
          <ProjectsMenu
            isOpen={isProjectsOpen}
            projects={navLinks.find(link => link.name === "Projects")?.projects || []}
            onProjectSelect={onClickSetCurrentProject}
            menuId="projects-menu-general"
          />
        </nav>
      </div>
    </div>
  );
};

GeneralHeaderView.propTypes = {
  navLinks: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      link: PropTypes.string,
      projects: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          title: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
  socialMediaIcons: PropTypes.array.isRequired,
  onClickSetCurrentProject: PropTypes.func.isRequired,
};

export default memo(GeneralHeaderView);
